<template>
  <slide-view v-model:toggle="info.menu.toggle">
    <a-flex gap="small" style="padding: 18px">
      <a-avatar size="large" :src="meta.brand.icon ? meta.brand.icon+'-sq.60' : ''">{{ meta.brand.name[0] }}</a-avatar>
      <a-flex vertical justify="center" v-if="!info.menu.toggle">
        <a-typography-text ellipsis :content="meta.brand.name"/>
        <a-typography-text type="secondary">{{ meta.branch.name }}</a-typography-text>
      </a-flex>
    </a-flex>
    <a-menu :items="info.menu.items" :inline-collapsed="info.menu.toggle" v-model:open-keys="info.menu.openKeys"
            v-model:selected-keys="info.menu.selectedKeys" mode="inline" @click="onMenuClick"/>
  </slide-view>
</template>

<script setup lang="ts">

import SlideView from "@/views/share/SlideView.vue";
import {h, reactive} from "vue";
import {MenuProps} from "ant-design-vue";
import {useRoute} from "vue-router";
import {UserAgent} from "@/model/user_agent";
import {InfoCircleOutlined, UserOutlined} from "@ant-design/icons-vue";
import router from "@/views";
import {IBranch, IBrand} from "@/model/brand_manager";

const route = useRoute();
const meta = {
  agent: route.meta.agent as UserAgent,
  brand: route.meta.brand as IBrand,
  branch: route.meta.branch as IBranch
};

const info = reactive({
  menu: {
    toggle: false,
    items: [
      {key: meta.branch.branch_id, icon: h(UserOutlined), label: '概况'},
      {key: 'customers', icon: h(UserOutlined), label: '新老客'},
      {key: 'signs', icon: h(UserOutlined), label: '报名顾客'},
      {key: 'distributors', icon: h(UserOutlined), label: '分销员'},
      {key: 'views', icon: h(UserOutlined), label: '访客记录'},
      {key: 'employees', icon: h(UserOutlined), label: '内部成员'},
      {key: 'orders', icon: h(UserOutlined), label: '订单管理'},
      {key: 'info', icon: h(InfoCircleOutlined), label: '门店信息'},
    ] as MenuProps['items'],
    openKeys: [] as string[],
    selectedKeys: [route.path.split('/').last()] as string[],
  }
});


const onMenuClick = (e: any) => {
  if (e.key === meta.branch.branch_id) router.push(`/brand/${meta.branch.brand_id}/branch/${meta.branch.branch_id}`);
  else router.push(`/brand/${meta.branch.brand_id}/branch/${meta.branch.branch_id}/${e.key}`);
}

</script>

<style scoped lang="sass">
:deep(.ant-menu-item)
  border: 1px solid #f1f1f1
  margin-top: 12px
</style>